// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2fAa8","productName":"Table_productName__2W003"};